import React from 'react';
import { SharePanelFormSection } from './section';

export const SharePanelFormCustomFieldsSectionLink = ({ disabled = false }: { disabled?: boolean }) => {
  return (
    <SharePanelFormSection
      type='custom-fields'
      title='Require custom fields'
      subTitle={`Require custom fields like visitor name and company name`}
      disabled={disabled}
    />
  );
};
